import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import {
  Card, BlockStack, InlineStack, Button, IndexTable, Checkbox,
} from '@shopify/polaris';
import { PlusIcon, DeleteIcon, EditIcon } from '@shopify/polaris-icons';

import { getAllUsers, userCreate, userDelete, userUpdate } from '../../redux/actions/users';
import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';

import NewUserDialog from './NewUserDialog';
import DeleteUserDialog from './DeleteUserDialog';
import EditUserDialog from './EditUserDialog';

const Users = ({ users, getUsers, createUser, deleteUser, updateUser }) => {
  const [activeUser, setActiveUser] = useState(null);
  const [displayNewUserDialog, setDisplayNewUserDialog] = useState(false);
  const [displayEditUserDialog, setDisplayEditUserDialog] = useState(false);
  const [displayDeleteUserDialog, setDisplayDeleteUserDialog] = useState(false);
  const [, setSubmitted] = useState(false);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const showDeleteDialog = (user) => {
    setActiveUser(user);
    setDisplayDeleteUserDialog(true);
  }

  const showEditDialog = (user) => {
    setActiveUser(user);
    setDisplayEditUserDialog(true);
  }

  const usersTableData = () => {
    let usersItemData = [];

    users.users.forEach((user) => {
      usersItemData.push({ email: user.email, loginName: user.login_name, picker: user.picker, packer: user.packer, stockReturn: user.stock_return });
    })

    return usersItemData;
  }

  const userRows = usersTableData();

  return(
    <SettingsPage title="Users" description="">
      <Card>
        <BlockStack gap="400">
          { !users.isFetching && users.users &&
            <>
              <IndexTable
                resourceName={{ singular: 'user', plural: 'users' }}
                itemCount={userRows.length}
                selectable={false}
                headings={[
                  { title: 'Email' },
                  { title: 'Login Name' },
                  { title: 'Picker' },
                  { title: 'Packer' },
                  { title: 'Stock Returns' },
                  { title: 'Actions' },
                ]}
              >
                {userRows.map((user, index) => (
                  <IndexTable.Row id={user.email} key={user.email} position={index}>
                    <IndexTable.Cell>{user.email}</IndexTable.Cell>
                    <IndexTable.Cell>{user.loginName}</IndexTable.Cell>
                    <IndexTable.Cell><Checkbox label="" labelHidden checked={user.picker} onChange={() => {}} /></IndexTable.Cell>
                    <IndexTable.Cell><Checkbox label="" labelHidden checked={user.packer} onChange={() => {}} /></IndexTable.Cell>
                    <IndexTable.Cell><Checkbox label="" labelHidden checked={user.stockReturn} onChange={() => {}} /></IndexTable.Cell>
                    <IndexTable.Cell>
                      <InlineStack gap="200">
                        <Button
                          icon={EditIcon}
                          onClick={() => showEditDialog(user)}
                          loading={users.updatingUser === user.email}
                          disabled={users.updatingUser === user.email || users.deletingUser === user.email}
                        >
                          Edit Permissions
                        </Button>
                        <Button
                          tone="critical"
                          icon={DeleteIcon}
                          onClick={() => showDeleteDialog(user)}
                          loading={users.deletingUser === user.email}
                          disabled={users.updatingUser === user.email || users.deletingUser === user.email}
                        >
                          Remove User
                        </Button>
                      </InlineStack>
                    </IndexTable.Cell>
                  </IndexTable.Row>
                ))}
              </IndexTable>

              { users.isCreating &&
                <LoadingSpinner size="small" statusText="Adding user"/>
              }

              <InlineStack align="start">
                <Button
                  variant="primary"
                  icon={PlusIcon}
                  onClick={() => setDisplayNewUserDialog(true)}
                >
                  New User
                </Button>
              </InlineStack>
            </>
          }

          { users.isFetching &&
            <LoadingSpinner size="small" statusText="Loading users"/>
          }
        </BlockStack>
      </Card>

      { displayNewUserDialog &&
        <NewUserDialog
          setDisplayNewUserDialog={setDisplayNewUserDialog}
          createUser={createUser}
          setSubmitted={setSubmitted}
          displayNewUserDialog={displayNewUserDialog}
        />
      }

      { displayDeleteUserDialog &&
        <DeleteUserDialog
          user={activeUser}
          setDisplayDeleteUserDialog={setDisplayDeleteUserDialog}
          deleteUser={deleteUser}
          setSubmitted={setSubmitted}
          displayDeleteUserDialog={displayDeleteUserDialog}
        />
      }

      { displayEditUserDialog &&
        <EditUserDialog
          activeUser={activeUser}
          setDisplayEditUserDialog={setDisplayEditUserDialog}
          updateUser={updateUser}
          setSubmitted={setSubmitted}
          displayEditUserDialog={displayEditUserDialog}
        />
      }

    </SettingsPage>
  )
}

const mapStateToProps = state => ({
  users: state.users,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: () => dispatch(getAllUsers()),
  createUser: (user) => dispatch(userCreate(user)),
  deleteUser: (email) => dispatch(userDelete(email)),
  updateUser: (user) => dispatch(userUpdate(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);
